import { render, staticRenderFns } from "./trainingsHubWorkoutTimeline.vue?vue&type=template&id=4c96ec0b&scoped=true"
import script from "./trainingsHubWorkoutTimeline.vue?vue&type=script&lang=js"
export * from "./trainingsHubWorkoutTimeline.vue?vue&type=script&lang=js"
import style0 from "./trainingsHubWorkoutTimeline.vue?vue&type=style&index=0&id=4c96ec0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c96ec0b",
  null
  
)

export default component.exports